"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  AccountingCoinsBill: ['accounting-coins-bill', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 14.250 A6 3 0 1 0 12.750 14.250 A6 3 0 1 0 0.750 14.250 Z', 'M.75,14.25v6c0,1.657,2.686,3,6,3s6-1.343,6-3v-6', 'M12.75,17.25c0,1.657-2.686,3-6,3s-6-1.343-6-3', 'M15.75,15.75h6a1.5,1.5,0,0,0,1.5-1.5v-12a1.5,1.5,0,0,0-1.5-1.5H2.25a1.5,1.5,0,0,0-1.5,1.5V9.757', 'M9,8.25a3,3,0,1,1,4.979,2.255', 'M4.5,4.125a.375.375,0,1,1-.375.375A.375.375,0,0,1,4.5,4.125', 'M19.5,11.625a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375']],
  MoneyWallet: ['money-wallet', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.75,18.5V20a3,3,0,0,1-3,3h-15a3,3,0,0,1-3-3V9.5a3,3,0,0,1,3-3h15a3,3,0,0,1,3,3V11', 'M18.75,6.5,16.421,1.842a1.5,1.5,0,0,0-2.013-.671L3.75,6.5', 'M21.75,18.5a1.5,1.5,0,0,0,1.5-1.5V12.5a1.5,1.5,0,0,0-1.5-1.5H18a3.75,3.75,0,0,0,0,7.5Z', 'M18,14.375a.375.375,0,1,1-.375.375A.375.375,0,0,1,18,14.375']],
  AccountingBillStack1: ['accounting-bill-stack-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.5,11.25H11.467a1.342,1.342,0,0,0-.5,2.587l2.064.826a1.342,1.342,0,0,1-.5,2.587H10.5', 'M12 11.25L12 9.75', 'M12 18.75L12 17.25', 'M6.75 21.75L6.75 6.75 9 2.25 15 2.25 17.25 6.75 17.25 21.75 6.75 21.75z', 'M15 2.25L20.25 2.25 23.25 6.75 17.25 6.75', 'M6.75 6.75L0.75 6.75 3.75 2.25 9 2.25', 'M0.75 10.5L6.75 10.5', 'M17.25 10.5L23.25 10.5', 'M0.75 14.25L6.75 14.25', 'M17.25 14.25L23.25 14.25', 'M0.75 18L6.75 18', 'M17.25 18L23.25 18', 'M6.75 21.75L0.75 21.75 0.75 6.75', 'M17.25 21.75L23.25 21.75 23.25 6.75', 'M17.25 6.75L6.75 6.75']],
  AccountingBill: ['accounting-bill', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.5,7.875a.375.375,0,1,1-.375.375A.375.375,0,0,1,4.5,7.875', 'M19.5,15.375a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M0.750 4.500 L23.250 4.500 L23.250 19.500 L0.750 19.500 Z', 'M9.000 12.000 A3.000 3.000 0 1 0 15.000 12.000 A3.000 3.000 0 1 0 9.000 12.000 Z']],
  AccountingBillStack: ['accounting-bill-stack', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 17.5L7.5 17.5', 'M7.5 6.25L0.75 6.25', 'M23.25 6.25L16.5 6.25', 'M16.5 17.5L23.25 17.5', 'M0.75 13.75L7.5 13.75', 'M0.75 10L7.5 10', 'M16.5 13.75L23.25 13.75', 'M16.5 10L23.25 10', 'M7.500 4.750 L16.500 4.750 L16.500 19.000 L7.500 19.000 Z', 'M10.142,14.094A2.221,2.221,0,0,0,12,14.969c1.139,0,2.063-.693,2.063-1.547S13.139,11.876,12,11.876s-2.062-.693-2.062-1.548S10.861,8.781,12,8.781a2.221,2.221,0,0,1,1.858.875', 'M12 14.969L12 16', 'M12 7.75L12 8.781']],
  AccountingBills1: ['accounting-bills-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.5,10.875a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M19.5,18.375a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M0.750 7.500 L23.250 7.500 L23.250 22.500 L0.750 22.500 Z', 'M9.000 15.000 A3.000 3.000 0 1 0 15.000 15.000 A3.000 3.000 0 1 0 9.000 15.000 Z', 'M2.25 4.5L21.75 4.5', 'M5.25 1.5L18.75 1.5']],
  CoinPurse1: ['coin-purse-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M7.000 3.500 A1.875 1.875 0 1 0 10.750 3.500 A1.875 1.875 0 1 0 7.000 3.500 Z', 'M13.000 3.500 A1.875 1.875 0 1 0 16.750 3.500 A1.875 1.875 0 1 0 13.000 3.500 Z', 'M.75,9.625A2.25,2.25,0,0,1,3,7.375H21a2.25,2.25,0,0,1,2.25,2.25', 'M17.2,22.375H6.8a4.5,4.5,0,0,1-4.31-5.793L5.25,7.375h13.5l2.762,9.207A4.5,4.5,0,0,1,17.2,22.375Z']],
  CoinPurse: ['coin-purse', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.263,21.75a1.5,1.5,0,0,1-1.5-1.7,11.382,11.382,0,0,1,22.466,0,1.5,1.5,0,0,1-1.5,1.7Z', 'M18.7,8.2A14.874,14.874,0,0,0,5.3,8.2', 'M7.500 4.500 A2.250 2.250 0 1 0 12.000 4.500 A2.250 2.250 0 1 0 7.500 4.500 Z', 'M12.000 4.500 A2.250 2.250 0 1 0 16.500 4.500 A2.250 2.250 0 1 0 12.000 4.500 Z']],
  MoneyAtm: ['money-atm', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.629,19.5H5.371a.75.75,0,0,1-.742-.861L6.75,4.5h10.5l2.121,14.139A.75.75,0,0,1,18.629,19.5Z', 'M4.5 22.5L19.5 22.5', 'M13.5,9H11.467a1.342,1.342,0,0,0-.5,2.587l2.064.826a1.342,1.342,0,0,1-.5,2.587H10.5', 'M12 9L12 7.5', 'M12 16.5L12 15', 'M3,9H1.5a.75.75,0,0,1-.75-.75v-6A.75.75,0,0,1,1.5,1.5h21a.75.75,0,0,1,.75.75v6A.75.75,0,0,1,22.5,9H21']],
  MoneyBags: ['money-bags', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M14.045,7.988C16.091,9.4,18.75,12.8,18.75,15.863c0,3.107-3.361,5.625-6.75,5.625S5.25,18.97,5.25,15.863C5.25,12.8,7.909,9.4,9.955,7.988L8.4,4.281a.9.9,0,0,1,.416-1.27,10.2,10.2,0,0,1,6.363,0A.9.9,0,0,1,15.6,4.281Z', 'M9.955 7.988L14.045 7.988', 'M4.5,20.738c-3,0-3.75-3-3.75-5.114A7.512,7.512,0,0,1,4.33,9.488L3.066,7.665a.75.75,0,0,1,.616-1.177H6', 'M10.329,17.332a2.225,2.225,0,0,0,1.858.876c1.139,0,2.063-.693,2.063-1.548s-.924-1.546-2.063-1.546-2.062-.693-2.062-1.548.924-1.547,2.062-1.547a2.221,2.221,0,0,1,1.858.875', 'M12.187 18.208L12.187 19.238', 'M12.187 10.988L12.187 12.019', 'M19.5,20.738c3,0,3.75-3,3.75-5.114a7.512,7.512,0,0,0-3.58-6.136l1.264-1.823a.75.75,0,0,0-.616-1.177H18']],
  AccountingBills: ['accounting-bills', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.125,7.5a.375.375,0,1,1-.375.375A.375.375,0,0,1,4.125,7.5', 'M16.875,12.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M0.750 4.500 L20.250 4.500 L20.250 16.500 L0.750 16.500 Z', 'M7.500 10.500 A3.000 3.000 0 1 0 13.500 10.500 A3.000 3.000 0 1 0 7.500 10.500 Z', 'M23.25,9v9a1.5,1.5,0,0,1-1.5,1.5H5.25']],
  AccountingCoinsStack: ['accounting-coins-stack', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 3.750 A6 3 0 1 0 12.750 3.750 A6 3 0 1 0 0.750 3.750 Z', 'M12.75,6.75c0,1.657-2.686,3-6,3s-6-1.343-6-3', 'M12.75 9.75L12.75 3.75', 'M.75,3.75v15c0,1.657,2.686,3,6,3A11.284,11.284,0,0,0,9,21.527', 'M.75,15.75c0,1.657,2.686,3,6,3A11.284,11.284,0,0,0,9,18.527', 'M.75,12.75c0,1.657,2.686,3,6,3A11.284,11.284,0,0,0,9,15.527', 'M.75,9.75c0,1.657,2.686,3,6,3A11.284,11.284,0,0,0,9,12.527', 'M11.250 14.250 A6 3 0 1 0 23.250 14.250 A6 3 0 1 0 11.250 14.250 Z', 'M11.25,14.25v6c0,1.657,2.686,3,6,3s6-1.343,6-3v-6', 'M23.25,17.25c0,1.657-2.686,3-6,3s-6-1.343-6-3']],
  MoneyBagDollar: ['money-bag-dollar', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.574,12.75H11.541a1.342,1.342,0,0,0-.5,2.587l2.064.826a1.342,1.342,0,0,1-.5,2.587H10.574', 'M12.074 12.75L12.074 12', 'M12.074 19.5L12.074 18.75', 'M6.824 8.25L17.324 8.25', 'M15.63,5.036,17.068,2.16a.75.75,0,0,0-1.006-1.006l-1.9.948a.75.75,0,0,1-.959-.255L12.7,1.084a.75.75,0,0,0-1.248,0l-.509.763a.749.749,0,0,1-.959.255L8.087,1.154A.751.751,0,0,0,7.08,2.16L8.49,4.98', 'M7.237,10.5l-2.76,3.2a5.932,5.932,0,0,0,4.7,9.549h5.79a5.932,5.932,0,0,0,4.7-9.549l-2.76-3.2']],
  MoneyWallet1: ['money-wallet-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.75,18v3a1.5,1.5,0,0,1-1.5,1.5H3A2.25,2.25,0,0,1,.75,20.25V3.75A2.25,2.25,0,0,1,3,1.5H18.75A1.5,1.5,0,0,1,20.25,3V5.25', 'M21.75,18a1.5,1.5,0,0,0,1.5-1.5V12a1.5,1.5,0,0,0-1.5-1.5H18A3.75,3.75,0,0,0,18,18Z', 'M18,13.875a.375.375,0,1,1-.375.375A.375.375,0,0,1,18,13.875', 'M21.75,10.5V6.75a1.5,1.5,0,0,0-1.5-1.5H5.625a1.756,1.756,0,0,1-1.614-.895']],
  AccountingCoinsStack1: ['accounting-coins-stack-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.750 18.750 L18.750 18.750 L18.750 23.250 L6.750 23.250 Z', 'M8.250 14.250 L20.250 14.250 L20.250 18.750 L8.250 18.750 Z', 'M3.750 9.750 L15.750 9.750 L15.750 14.250 L3.750 14.250 Z', 'M5.250 5.250 L17.250 5.250 L17.250 9.750 L5.250 9.750 Z', 'M21.75 7.5L21.75 10.5', 'M20.25 9L23.25 9', 'M2.25 0.75L2.25 3.75', 'M0.75 2.25L3.75 2.25']],
  AccountingWithdraw: ['accounting-withdraw', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M14.758,21.375H2.25a.75.75,0,0,1-.742-.861L7.379,6.375h10.5L15.5,20.514A.75.75,0,0,1,14.758,21.375Z', 'M12.525,11.2,10.556,10.7a1.341,1.341,0,0,0-1.125,2.382l1.793,1.312A1.341,1.341,0,0,1,10.1,16.772l-1.97-.5', 'M11.072 10.828L11.445 9.375', 'M9.21 18.093L9.582 16.64', 'M2.25,10.125H1.5a.75.75,0,0,1-.75-.75v-6a.75.75,0,0,1,.75-.75h21a.75.75,0,0,1,.75.75v6a.75.75,0,0,1-.75.75H20.25']],
  MoneyBagEuro: ['money-bag-euro', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.279 14.25L12.779 14.25', 'M8.279 17.25L12.779 17.25', 'M12.779,11.525a4.475,4.475,0,0,0,0,8.45', 'M6.779 8.25L17.279 8.25', 'M15.585,5.036,17.023,2.16a.751.751,0,0,0-1.007-1.006L14.121,2.1a.749.749,0,0,1-.959-.255l-.509-.763a.75.75,0,0,0-1.248,0l-.509.763a.75.75,0,0,1-.959.255l-1.9-.948A.75.75,0,0,0,7.035,2.16l1.41,2.82', 'M7.192,10.5l-2.76,3.2a5.932,5.932,0,0,0,4.7,9.549h5.79a5.932,5.932,0,0,0,4.7-9.549l-2.76-3.2']],
  AccountingWithdrawAlternate: ['accounting-withdraw-alternate', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M14.758,21.375H2.25a.75.75,0,0,1-.742-.861l.206-.974A37.775,37.775,0,0,1,7.379,6.375h10.5A35.685,35.685,0,0,0,15.5,20.514.75.75,0,0,1,14.758,21.375Z', 'M12.525,11.2,10.556,10.7a1.341,1.341,0,0,0-1.125,2.382l1.793,1.312A1.341,1.341,0,0,1,10.1,16.772l-1.97-.5', 'M11.072 10.828L11.445 9.375', 'M9.21 18.093L9.582 16.64', 'M2.25,10.125H1.5a.75.75,0,0,1-.75-.75v-6a.75.75,0,0,1,.75-.75h21a.75.75,0,0,1,.75.75v6a.75.75,0,0,1-.75.75H20.25']],
  MoneyWalletOpen: ['money-wallet-open', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.97,2.771,13.908,5.88a3.769,3.769,0,0,1,2.592,3.5v10.51a2.052,2.052,0,0,1-2.6,2.167l-9.048-2.46a3.7,3.7,0,0,1-2.6-3.457V4.688A2.752,2.752,0,0,1,4.922,1.875H18.75a3,3,0,0,1,3,3v8.953a3.074,3.074,0,0,1-3.11,3.047H16.5', 'M12.375,13.125A.375.375,0,1,1,12,13.5a.375.375,0,0,1,.375-.375', 'M21.75 9.375L16.5 9.375']]
};
exports["default"] = _default;